import _defineProperty from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { Node, mergeAttributes, textblockTypeInputRule } from '@tiptap/core';
var Heading = Node.create({
  name: 'heading',
  addOptions: function addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: 'inline*',
  group: 'block',
  defining: true,
  addAttributes: function addAttributes() {
    return {
      level: {
        default: 1,
        rendered: false
      }
    };
  },
  parseHTML: function parseHTML() {
    return this.options.levels.map(function (level) {
      return {
        tag: "h".concat(level),
        attrs: {
          level: level
        }
      };
    });
  },
  renderHTML: function renderHTML(_ref) {
    var node = _ref.node,
      HTMLAttributes = _ref.HTMLAttributes;
    var hasLevel = this.options.levels.includes(node.attrs.level);
    var level = hasLevel ? node.attrs.level : this.options.levels[0];
    return ["h".concat(level), mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addCommands: function addCommands() {
    var _this = this;
    return {
      setHeading: function setHeading(attributes) {
        return function (_ref2) {
          var commands = _ref2.commands;
          if (!_this.options.levels.includes(attributes.level)) {
            return false;
          }
          return commands.setNode(_this.name, attributes);
        };
      },
      toggleHeading: function toggleHeading(attributes) {
        return function (_ref3) {
          var commands = _ref3.commands;
          if (!_this.options.levels.includes(attributes.level)) {
            return false;
          }
          return commands.toggleNode(_this.name, 'paragraph', attributes);
        };
      }
    };
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this2 = this;
    return this.options.levels.reduce(function (items, level) {
      return _objectSpread(_objectSpread({}, items), _defineProperty({}, "Mod-Alt-".concat(level), function ModAlt() {
        return _this2.editor.commands.toggleHeading({
          level: level
        });
      }));
    }, {});
  },
  addInputRules: function addInputRules() {
    var _this3 = this;
    return this.options.levels.map(function (level) {
      return textblockTypeInputRule({
        find: new RegExp("^(#{1,".concat(level, "})\\s$")),
        type: _this3.type,
        getAttributes: {
          level: level
        }
      });
    });
  }
});
export { Heading, Heading as default };